"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _includes = _interopRequireDefault(require("lodash/fp/includes"));
var _eventBubbleFilter = _interopRequireDefault(require("@active/react-utils/eventHandler/eventBubbleFilter"));
var _constants = require("../constants");
var _comboBoxBase = _interopRequireDefault(require("./comboBoxBase"));
var _focusUtils = require("./focusUtils");
function useSelectOnlyComboBox(_ref) {
  var byMouse = _ref.byMouse,
    disabled = _ref.disabled,
    expanded = _ref.expanded,
    setExpanded = _ref.setExpanded,
    comboBoxRef = _ref.comboBoxRef,
    listBoxRef = _ref.listBoxRef;
  var handleComboBoxConfirm = _react["default"].useCallback(function (event) {
    (0, _eventBubbleFilter["default"])(function (e) {
      if (!(0, _includes["default"])(e.key)([_constants.KEY_VALUES.ENTER, _constants.KEY_VALUES.SPACE, _constants.KEY_VALUES.UPARROW, _constants.KEY_VALUES.DOWNARROW])) {
        return;
      }
      if (disabled) {
        return;
      }
      e.preventDefault();
      setExpanded({
        expanded: true
      });
    })(event);
  }, [disabled, setExpanded]);
  _react["default"].useEffect(function handleListBoxExpande() {
    if (!expanded || !(listBoxRef !== null && listBoxRef !== void 0 && listBoxRef.current)) {
      return;
    }
    var elementToFocus = listBoxRef.current;
    if (byMouse) {
      (0, _focusUtils.focus)(elementToFocus);
    } else {
      setTimeout(function () {
        (0, _focusUtils.emitFocusListBoxItem)(elementToFocus);
      }, 0);
    }
  }, [byMouse, expanded, listBoxRef]);
  _react["default"].useEffect(function addEventListeners() {
    var comboBox = comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current;
    comboBox === null || comboBox === void 0 || comboBox.addEventListener('keydown', handleComboBoxConfirm);
    return function () {
      comboBox === null || comboBox === void 0 || comboBox.removeEventListener('keydown', handleComboBoxConfirm);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comboBoxRef, comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current, handleComboBoxConfirm]);
}
var _default = exports["default"] = (0, _comboBoxBase["default"])(useSelectOnlyComboBox);